import styled from 'styled-components';

export const AssignmentFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;

  width: 100%;
  margin: 0 10px;

  .close-btn,
  .filter-btn {
    font-weight: bold;
    background-color: transparent;
    border: 0;
    color: white;

    .isvg {
      color: #425464;
      padding: 0;
    }
  }

  .close-btn {
    padding: 0 8px;
  }
`;

export const FilterLabel = styled.span`
  font-size: 11.5px;
  border-radius: 10px;
  background-color: #f4f4f4;
  padding: 2px 10px;
`;

export const FilerRow = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-top: 3px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 21px;

  [class^='svgIconComponent'] {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
  }
`;
